import { useMutation } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { PromocodeBatch } from "@modules/promocodeBatches/types";
import { PromocodeBatchFormValues } from "@modules/promocodeBatches/validations";

import { createPromocodeBatchService } from "./service";
import { UseCreatePromocodeBatchMutationOptions } from "./types";

export function useCreatePromocodeBatchMutation(
  options?: UseCreatePromocodeBatchMutationOptions
) {
  const { open } = useNotification();

  return useMutation<PromocodeBatch, ApiError, PromocodeBatchFormValues>({
    mutationFn: createPromocodeBatchService,
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
